<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{formType === 'create' ? $t('report.create_report_setting') : $t('report.set_field')}}</div>
    <div slot="body" class="scroll-dialog-body">
      <div v-if="formType === 'create'" class="mb-2">
        <steps v-model="stepModel" />
      </div>
      <!-- 新建模板 -->
      <a-form v-if="formType === 'create' && stepModel.currentStep === 0" :form="form.fc" v-bind="formLayout">
        <!-- 域 -->
        <a-form-item :label="$t('report.owner_domain')">
          <domain-select v-if="isAdminMode && l3PermissionEnable" v-decorator="decorators.project_domain_id" :params="domainParams" @change="handleDomainChange" />
          <template v-else> {{userInfo.projectDomain}} </template>
        </a-form-item>
        <a-form-item :label="$t('report.statistical_object')">
          <a-radio-group v-decorator="decorators.target_type">
            <a-radio-button value="domains" v-if="isAdminMode">{{$t('report.target_type_object.domains')}}</a-radio-button>
            <a-radio-button value="projects" v-if="isAdminMode">{{$t('report.target_type_object.projects')}}</a-radio-button>
            <a-radio-button value="domain">{{isAdminMode ? $t('report.target_type_object.domain') : $t('report.target_type_object.current_domain')}}</a-radio-button>
            <a-radio-button value="project">{{$t('report.target_type_object.project')}}</a-radio-button>
            <a-radio-button value="domain_project">{{isAdminMode ? $t('report.target_type_object.domain_project') : $t('report.target_type_object.current_domain_project')}}</a-radio-button>
            <a-radio-button value="cloudaccount">{{$t('report.target_type_object.cloudaccount')}}</a-radio-button>
            <a-radio-button value="project_metadata">{{$t('report.target_type_object.project_metadata')}}</a-radio-button>
            <a-radio-button value="domain_server">{{$t('report.target_type_object.domain_server')}}</a-radio-button>
            <a-radio-button value="project_server">{{$t('report.target_type_object.project_server')}}</a-radio-button>
          </a-radio-group>
          <a-form-item v-if="isAdminMode && (form.fd.target_type === 'domain' || form.fd.target_type === 'domain_project' || form.fd.target_type === 'domain_server')">
            <base-select
              v-decorator="decorators.target_id"
              resource="domains"
              remote
              :select-props="{placeholder: $t('common.tips.select', [$t('dictionary.domain')])}"
              :params="domainParams" />
          </a-form-item>
          <a-form-item v-if="form.fd.target_type === 'project' || form.fd.target_type === 'project_server'">
            <base-select
              v-decorator="decorators.target_id"
              resource="projects"
              :select-props="{placeholder: $t('common.tips.select', [$t('dictionary.project')])}"
              remote
              :params="projectParams" />
          </a-form-item>
          <a-form-item v-if="form.fd.target_type === 'cloudaccount'">
            <base-select
              v-decorator="decorators.target_id"
              resource="cloudaccounts"
              remote
              :select-props="{placeholder: $t('common.tips.select', [$t('dictionary.cloudaccount')])}"
              :params="accountParams" />
          </a-form-item>
          <a-form-item class="mt-2" v-if="form.fd.target_type === 'project_metadata'">
            <tag
              v-decorator="decorators.metadata"
              extra=""
              :canCreate="false"
              :params="{service: 'identity', user_meta: true}" />
          </a-form-item>
        </a-form-item>
        <!-- 名称 -->
        <a-form-item :label="$t('cloudenv.text_95')">
          <a-input v-decorator="decorators.name" :placeholder="$t('common.tips.input', [$t('cloudenv.text_95')])" />
        </a-form-item>
        <!-- 策略 -->
        <a-from-item :label="$t('')">
          <cron-form :form="form" />
        </a-from-item>
      </a-form>
      <!-- 设置字段 -->
      <div v-else>
        <dialog-selected-tips :name="$t('report.report_setting')" :count="1" :action="$t('report.set_field')" />
        <dialog-table :data="[reportSetting]" :columns="columns" />
        <div class="mt-3 mb-1 d-flex align-items-center justify-content-start">
          <span>{{$t('report.report_elements_order')}}:</span>
          <a-button type="link" @click="handleOpenSelect">{{$t('report.change_field')}}</a-button>
        </div>
        <a-row>
          <draggable
            handle=".drag-icon"
            ghost-class="ghost"
            v-model="reportElements">
            <transition-group type="transition" name="flip-list">
              <template v-for="(item, index) of reportElements">
                <a-col
                  v-if="item.name"
                  :span="8"
                  :key="item.id"
                  class="mb-2 drag-item d-flex align-items-center">
                  <div class="drag-item-bg" />
                  <span class="label" :title="item.name">{{index + 1}}. {{ item.name }}</span>
                  <a-icon type="drag" class="drag-icon pr-3" />
                </a-col>
              </template>
            </transition-group>
          </draggable>
        </a-row>
      </div>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import CronForm from '@Reports/sections/CronForm'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import DomainSelect from '@/sections/DomainSelect'
import Tag from '@/sections/Tag'
import { getNameFilter } from '@/utils/common/tableFilter'
import { getReportElementTypeColumn, getReportElementKeyColumn } from '../../../utils/columns'

export default {
  name: 'ReportSettingCreateDialog',
  components: {
    DomainSelect,
    CronForm,
    draggable,
    Tag,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    const projectDomainInitialValue = (this.params.domain && this.params.domain.key) || this.$store.getters.userInfo.projectDomainId
    const initTargetType = this.$store.getters.isAdminMode ? 'domains' : 'domain'
    const initReportSetting = this.params.type === 'create' ? {} : this.params.data[0]
    return {
      formType: this.params.type,
      reportSetting: initReportSetting,
      stepModel: {
        steps: [
          { title: this.$t('report.create_report_setting') },
          { title: this.$t('report.set_field') },
        ],
        currentStep: 0,
      },
      form: {
        fc: this.$form.createForm(this, {
          onValuesChange: (props, values) => {
            Object.keys(values).forEach((key) => {
              this.form.fd[key] = values[key]
            })
          },
        }),
        fd: {
          target_type: initTargetType,
        },
      },
      decorators: {
        name: [
          'name',
          {
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('cloudenv.text_190') },
            ],
          },
        ],
        project_domain_id: [
          'project_domain_id',
          {
            initialValue: projectDomainInitialValue,
            rules: [
              { required: true, message: this.$t('cloudenv.text_284', [this.$t('dictionary.domain')]) },
            ],
          },
        ],
        target_type: [
          'target_type',
          {
            initialValue: initTargetType,
            rules: [
              { required: true },
            ],
          },
        ],
        target_id: [
          'target_id',
          {
            rules: [
              { required: true, message: this.$t('common.tips.select', ['']) },
            ],
          },
        ],
        // 设置字段
        report_element_ids: [
          'report_element_ids',
          {
            initialValue: (initReportSetting.elements || []).map(item => item.id),
          },
        ],
        metadata: [
          'metadata',
          {
            rules: [
              { required: true, validator: this.validateTag },
            ],
          },
        ],
      },
      formLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
      reportElements: R.clone(initReportSetting.elements || []),
      reportElementListProps: {
        list: this.$list.createList(this, {
          resource: 'report_elements',
          apiVersion: 'v1',
          filterOptions: {
            name: getNameFilter(),
          },
          limit: 10,
          disableStorageLimit: true,
        }),
        columns: [
          {
            field: 'name',
            title: this.$t('table.title.name'),
            showOverflow: 'title',
          },
          getReportElementTypeColumn(),
          getReportElementKeyColumn(),
        ],
      },
      projectDomainId: projectDomainInitialValue,
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'isDomainMode', 'scope', 'userInfo', 'l3PermissionEnable']),
    columns () {
      return this.params.columns.filter(item => ['name', 'cron_expression', 'elements'].includes(item.field))
    },
    domainParams () {
      const ret = {
        limit: 20,
        scope: this.scope,
      }
      return ret
    },
    projectParams () {
      const ret = {
        limit: 20,
        scope: this.scope,
      }
      if (this.isDomainMode) {
        ret.filter = `parent_id.in(${`'${this.userInfo.projectDomainId}'`})`
      }
      return ret
    },
    accountParams () {
      const ret = {
        limit: 20,
        scope: this.scope,
      }
      return ret
    },
  },
  methods: {
    validateTag (rules, val, callback) {
      if (!val) {
        callback(new Error(this.$t('common.tips.select', [this.$t('report.target_type_object.project_metadata')])))
      }
      callback()
    },
    genCronParams (form) {
      const { cycleTimer = {}, hourMinute, timer } = form
      const { cycle_type } = cycleTimer
      const time = this.$moment(hourMinute || timer.execTime)
      if (cycle_type === 'one') {
        return { cron_expression: time.format('m H D M *'), expired_at: time.add('hours', 1).format('YYYY-MM-DD HH:mm:ss') }
      }
      if (cycle_type === 'day') {
        return { cron_expression: `${time.format('m')} ${time.format('H')} * * ?` }
      }
      if (cycle_type === 'week') {
        const { week_days = [] } = cycleTimer
        const newWeekdays = week_days.map(day => {
          return day === 7 ? 0 : day
        })
        return { cron_expression: `${time.format('m')} ${time.format('H')} * * ${newWeekdays.join(',')}` }
      }
      if (cycle_type === 'month') {
        const { month_days = [] } = cycleTimer
        return { cron_expression: `${time.format('m')} ${time.format('H')} ${month_days.join(',')} * ?` }
      }
      if (cycle_type === 'year') {
        const { year_months = [], year_days = [] } = cycleTimer
        return { cron_expression: `${time.format('m')} ${time.format('H')} ${year_days.join(',')} ${year_months.join(',')} *` }
      }
      return { cron_expression: '' }
    },
    genCreateData (values) {
      const data = {
        name: values.name,
        target_type: values.target_type,
        ...(this.genCronParams(values)),
      }
      if (values.target_id) {
        data.target_id = values.target_id
      } else if (values.target_type === 'domain' || values.target_type === 'domain_project') {
        data.target_id = this.userInfo.projectDomainId
      } else if (values.target_type === 'project_metadata') {
        data.metadata = values.metadata
      }
      return data
    },
    handleSelected (data, details) {
      this.reportElements = details
    },
    handleOpenSelect () {
      this.createDialog('ListSelectDialog', {
        listProps: this.reportElementListProps,
        selected: this.reportElements.map(item => item.id),
        details: R.clone(this.reportElements),
        ok: this.handleSelected,
        idKey: 'id',
        formatterLabel: row => `${row.name}`,
        multiple: true,
        dialogParams: { mask: false, width: 900, title: this.$t('report.report_elements') },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        // 新建
        if (this.formType === 'create' && this.stepModel.currentStep === 0) {
          const data = this.genCreateData(values)
          const res = await this.params.onManager('create', {
            managerArgs: {
              data,
            },
          })
          this.loading = false
          this.reportSetting = res.data
          this.stepModel.currentStep = 1
        } else {
        // 设置字段
          const ids = this.reportElements.map(item => item.id)
          if (ids.length === 0) {
            const delIds = (this.reportSetting.elements || []).map(item => item.id)
            if (delIds.length) {
              await this.params.onManager('performAction', {
                id: this.params.data[0].id,
                managerArgs: {
                  action: 'remove-elements',
                  data: {
                    report_element_ids: delIds,
                  },
                },
              })
            }
          } else {
            await this.params.onManager('performAction', {
              id: this.reportSetting.id,
              managerArgs: {
                action: 'set-elements',
                data: {
                  report_element_ids: ids,
                },
              },
            })
          }
          this.loading = false
          this.cancelDialog()
        }
      } catch (error) {
        this.loading = false
        throw error
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.drag-item {
  padding: 5px;
  .drag-item-bg {
    width: calc(100% - 10px);
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: #eee;
    z-index: 0;
  }
  .label {
    display: inline-block;
    padding-right: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    z-index: 1;
  }
  .drag-icon {
    position: absolute;
    right: 0;
    cursor: move;
    z-index: 2;
  }
  &:hover {
    .drag-icon {
      visibility: visible;
    }
  }
}

.ghost {
  opacity: 0.7;
  ::v-deep {
    label span {
      color: #fff;
    }
  }
}
</style>
